const QRCode = require('qrcode');

export const useDownloadQR = () => {
    function download(content: string, params?: { fileName: string }) {
        const fileName = params?.fileName ?? 'QR';

        const opts = {
            errorCorrectionLevel: 'H',
            type: 'image/jpeg',
            quality: 0.92,
            margin: 1,
            width: 500
        };

        QRCode.toDataURL(content, opts, function (err, url) {
            if (err) throw err;

            const link = document.createElement('a');

            document.body.appendChild(link);

            link.setAttribute('href', url);
            link.setAttribute('download', `${fileName}.jpg`);
            link.click();
        });
    }

    return {
        download
    };
};
